import { render } from "./SkyButton.vue?vue&type=template&id=601c8766&scoped=true"
import script from "./SkyButton.vue?vue&type=script&lang=js"
export * from "./SkyButton.vue?vue&type=script&lang=js"

import "./SkyButton.vue?vue&type=style&index=0&id=601c8766&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-601c8766"]])

export default __exports__